export const parseUrlParams = (param: string, defaultValue: string = ""): string => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param) || defaultValue;
};
